import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TaskGroupContact from '../components/TaskGroupContact';

const AdvisoryTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter members who are in Advisory Task Group
  const getTaskGroupMembers = () => {
    if (!teamData.boardMembers || !teamData.honoraryMembers) return [];

    const allMembers = [
      ...teamData.boardMembers,
      ...teamData.honoraryMembers
    ].filter(member =>
      member.taskGroups && member.taskGroups.includes('Advisory Task Group')
    );

    // Define the desired order
    const memberOrder = [
      'Marie-Christine Cabié',
      'Chris Iveson',
      'Ferdinand Wolf',
      'John Wheeler',
      'Jacek Lelonkiewicz'
    ];

    // Sort members according to the defined order
    return allMembers.sort((a, b) => {
      const indexA = memberOrder.indexOf(a.name);
      const indexB = memberOrder.indexOf(b.name);

      // If both are in the order list, use that order
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      // If only a is in the order list, it comes first
      if (indexA !== -1) return -1;

      // If only b is in the order list, it comes first
      if (indexB !== -1) return 1;

      // If neither are in the list, keep original order
      return 0;
    });
  };

  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const activityCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginBottom: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link 
          to="/task-groups" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          💡 Advisory Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Promoting ethical practices and providing guidance within the EBTA community
        </p>
      </div>

      {/* Mission */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎯</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Mission</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The Advisory Task Group promotes ethical practices within EBTA. It creates an ethical code, 
          provides ethical guidance and mediates in conflicts among EBTA members.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          The Advisory Task Group may act on the request of any EBTA member. The Advisory Task Group is composed 
          of widely respected members of the solution-focused community and past board members.
        </p>
      </div>

      {/* Code of Ethics */}
      <div style={{...sectionStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>📜</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#166534', margin: 0}}>Code of Ethics</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem', alignItems: 'start'}}>
          <div>
            <p style={{color: '#166534', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              <strong>EBTA maintains a comprehensive Code of Ethics that guides all members in their professional practice.</strong>
            </p>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              Our ethical framework ensures that solution-focused practitioners maintain the highest standards of 
              professional conduct, client care, and community responsibility.
            </p>
            <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '2rem'}}>
              The Code of Ethics covers areas such as professional competence, client welfare, confidentiality, 
              informed consent, and ethical decision-making in complex situations.
            </p>
          </div>
          
          <div style={{textAlign: 'center'}}>
            <div style={{
              backgroundColor: '#ffffff',
              padding: '2rem',
              borderRadius: '12px',
              border: '2px solid #bbf7d0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                width: '120px',
                height: '120px',
                backgroundColor: '#dcfce7',
                borderRadius: '50%',
                margin: '0 auto 1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '3rem',
                color: '#059669'
              }}>
                📜
              </div>
              <h4 style={{color: '#166534', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>
                Code of Ethics
              </h4>
              <p style={{color: '#6b7280', fontSize: '0.9rem', marginBottom: '1.5rem'}}>
                Professional standards for all EBTA members
              </p>
              <a 
                href="/pdfs/EBTA_code_of_ethics.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#059669',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#047857';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#059669';
                }}
              >
                View Code of Ethics →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* How to Request Support */}
      <div style={{...sectionStyle, backgroundColor: '#fef3c7', border: '1px solid #fde047'}}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem', color: '#d97706'}}>📞</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#a16207', margin: 0}}>Request Advisory Support</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem', alignItems: 'start'}}>
          <div>
            <p style={{color: '#a16207', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              <strong>Any EBTA member can request support from the Advisory Task Group.</strong>
            </p>
            <p style={{color: '#a16207', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
              Whether you're facing an ethical dilemma, need guidance on professional conduct, or require 
              mediation in a conflict situation, our experienced advisory team is here to help.
            </p>
            
            <div style={{
              backgroundColor: '#fde68a',
              padding: '1.5rem',
              borderRadius: '8px',
              marginBottom: '1.5rem'
            }}>
              <h4 style={{color: '#a16207', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>When to Contact Us</h4>
              <ul style={{color: '#a16207', fontSize: '1rem', lineHeight: '1.6', paddingLeft: '1.5rem', margin: 0}}>
                <li>Ethical dilemmas in practice</li>
                <li>Professional conduct questions</li>
                <li>Conflicts with other members</li>
                <li>Guidance on EBTA standards</li>
                <li>Code of Ethics clarification</li>
              </ul>
            </div>
            
            <p style={{color: '#a16207', fontSize: '1rem', lineHeight: '1.6'}}>
              All requests are handled with complete confidentiality and professional discretion.
            </p>
          </div>
          
          <div style={{textAlign: 'center'}}>
            <div style={{
              backgroundColor: '#ffffff',
              padding: '2rem',
              borderRadius: '12px',
              border: '2px solid #fde047',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
              <div style={{
                width: '120px',
                height: '120px',
                backgroundColor: '#fef3c7',
                borderRadius: '50%',
                margin: '0 auto 1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '3rem',
                color: '#d97706'
              }}>
                📞
              </div>
              <h4 style={{color: '#a16207', fontSize: '1.2rem', fontWeight: '600', marginBottom: '1rem'}}>
                Confidential Support
              </h4>
              <p style={{color: '#6b7280', fontSize: '0.9rem', marginBottom: '1.5rem'}}>
                Professional guidance available to all EBTA members
              </p>
              <Link 
                to="/contact"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#d97706',
                  color: 'white',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '0.9rem',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#b45309';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#d97706';
                }}
              >
                Contact Us →
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Advisory Task Group Members</h2>
        </div>
        
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getTaskGroupMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '0.5rem'}}>
                  {member.name}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Contact & Support */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📧</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Need Ethical Guidance?</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '1.5rem', maxWidth: '600px', margin: '0 auto 1.5rem'}}>
          Facing an ethical dilemma or need professional guidance?
        </p>
        <p style={{fontSize: '1rem', color: '#64748b', marginBottom: '2rem'}}>
          Contact our Advisory Task Group for confidential support and guidance.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact Advisory Group
          </Link>
          <Link 
            to="/about"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>💡</span>
            Learn About EBTA
          </Link>
        </div>
      </div>

      <TaskGroupContact taskGroupName="Advisory Task Group" />
    </div>
  );
};

export default AdvisoryTaskGroup;
